<template>
  <v-card>
    <v-card-title class="headline">Feedback</v-card-title>
    <v-card-text>
      <form @submit.prevent="sendFeedback">
        <div class="field">
          <v-textarea filled v-model="message" placeholder="Write your feedback"></v-textarea>
          <input type="hidden" name="user-id" v-model="userId">
        </div>
        <div class="field">
          <v-btn color="primary" type="submit">Send</v-btn>
        </div>
      </form>
      <button v-on:click="closeModal" class="modal-close is-large"></button>
    </v-card-text>
  </v-card>
</template>

<script>
import appFeedbackApi from '../api/appFeedbackApi';

export default {
  name: 'app-feedback-modal',
  computed: {
    userId() {
      return this.$store.getters.userId;
    }
  },
  data: () => ({
    message: null
  }),
  methods: {
    sendFeedback() {
      appFeedbackApi.sendFeedback(this.userId, this.message).then(() => {
        this.$emit('feedbackModalClosed');
      })
        .catch((error) => {
          console.error('Error adding feedback: ', error);
        });
    },

    closeModal() {
      this.$emit('feedbackModalClosed');
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppFeedbackModal.vue